module["exports"] = [
  "####",
  "####",
  "####",
  "0###"
];
